import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { Reoverlay } from 'reoverlay';

const CloseModalsOnNavigate = (): null => {
  const { pathname, search } = useLocation();
  const navigationType = useNavigationType();
  const previousUrlRef = useRef(`${pathname}${search}`);

  useEffect(() => {
    const currentUrl = `${pathname}${search}`;

    if (previousUrlRef.current === currentUrl) {
      return;
    }

    previousUrlRef.current = currentUrl;

    if (navigationType === 'REPLACE') {
      return;
    }

    Reoverlay.hideAll();
  }, [pathname, search, navigationType]);

  return null;
};

export default CloseModalsOnNavigate;
